/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Admin_Billing_Unusable_ManyInputs */



/**
* | output |
* | --- |
* | "{count} reports have unreadable totals and are NOT included in the figure above. The invoicing worker leaves them out of their months' invoices — the rest of..." |
*
* @param {Partner_Admin_Billing_Unusable_ManyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_unusable_many = /** @type {((inputs: Partner_Admin_Billing_Unusable_ManyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Unusable_ManyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bei ${i?.count} Berichten ist die Gesamtsumme nicht lesbar; sie sind im obigen Betrag NICHT enthalten. Der Rechnungslauf lässt sie aus den Rechnungen ihrer Monate heraus – der übrige Monat wird jeweils weiterhin abgerechnet –, sodass diese Berichte erst abgerechnet werden, wenn ihre Daten korrigiert sind.`)
	return /** @type {LocalizedString} */ (`${i?.count} reports have unreadable totals and are NOT included in the figure above. The invoicing worker leaves them out of their months' invoices — the rest of each month still bills — so these reports are never invoiced until their data is fixed.`)
});